// Title.js
import styles from './Title.module.scss';

type Props = {
  text: string;
  size?: 'small' | 'medium' | 'large'; // Add size prop
};

const Title = ({ text, size = 'large' }: Props) => {
  const titleClassName = `${styles.title} ${styles[size]}`; // Include size in the class name

  return <h2 className={titleClassName}>{text}</h2>;
};

export default Title;
